import { BaseModel } from "./base"
import { Device } from "./device";
import { JsonProperty } from "../requests/jsonparser";

export enum SubscriptionType {
    Standard = "Standard",
    Premium = "Premium"
}

export class PricingInfo extends BaseModel {

    @JsonProperty({ type: 'false' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'PricingInfo' })
    MODELNAME: string;

    @JsonProperty({ type: 'number' })
    amount: number;

    @JsonProperty({ type: 'number?' })
    trial?: number;

    @JsonProperty({ type: 'string' })
    currency: string;

    @JsonProperty({ type: 'string' })
    interval: 'day' | 'week' | 'month' | 'year';
}

export class Package extends BaseModel {

    @JsonProperty({ type: 'false' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'Package' })
    MODELNAME: string;

    @JsonProperty({ type: 'string' })
    type: SubscriptionType;

    @JsonProperty({ type: 'string' })
    description: string;

    @JsonProperty({ type: 'string' })
    name: string;

    @JsonProperty({ type: 'number' })
    order: number;

    @JsonProperty({ type: 'number' })
    num_clients: number;

    @JsonProperty({ clazz: PricingInfo, type: 'PricingInfo' })
    pricing_infos: PricingInfo[]
}



// WEBPACK FOOTER //
// ./src/api/models/package.ts